import { CardType } from '@spartacus/core';
import { CustomCheckoutActions } from "../actions";
import { CardTypesState } from '../custom-checkout-state';

export const initialState: CardTypesState = {
  entities: {},
};

export function reducer(
  state = initialState,
  action:
    | CustomCheckoutActions.CardTypesAction
    | CustomCheckoutActions.CheckoutClearMiscsData
): CardTypesState {
  switch (action.type) {
    case CustomCheckoutActions.LOAD_CARD_TYPES_SUCCESS: {
      const cardTypes: CardType[] = action.payload;
      const entities = cardTypes.reduce(
        (cardTypesEntities: { [code: string]: CardType }, name: CardType) => {
          return {
            ...cardTypesEntities,
            [name.code]: name,
          };
        },
        {
          ...state.entities,
        }
      );

      return {
        ...state,
        entities,
      };
    }

    case CustomCheckoutActions.CHECKOUT_CLEAR_MISCS_DATA: {
      return initialState;
    }
  }

  return state;
}

export const getCardTypesEntites = (state: CardTypesState) => state.entities;
